import { RouteRecordRaw } from 'vue-router';
import { defaultMetaAppointmentBooking } from '../routesSetup';
import AppointmentBookingPatientDetailsView from '../../lib/pages/AppointmentBookingPatientDetailsView.vue';
import AppointmentReasonView from '../../lib/pages/AppointmentReasonView.vue';
import ChooseAppointmentView from '../../lib/pages/ChooseAppointmentView.vue';
import AppointmentBookedView from '../../lib/pages/AppointmentBookedView.vue';

// `reason-for-appointment` is conditional — the store's step chain omits it
// when the link doesn't require a reason, rather than redirecting through it.
const appointmentBookingChildren: RouteRecordRaw[] = [
  {
    path: 'patient-details',
    name: 'appointment-booking-patient-details',
    component: AppointmentBookingPatientDetailsView,
    meta: {
      ...defaultMetaAppointmentBooking,
      layoutPageTitle: 'Your details',
      pageTitle: 'Your details',
    },
  },
  {
    path: 'reason-for-appointment',
    name: 'appointment-booking-reason-for-appointment',
    component: AppointmentReasonView,
    meta: {
      ...defaultMetaAppointmentBooking,
      layoutPageTitle: 'Reason for appointment',
      pageTitle: 'Reason for appointment',
    },
  },
  {
    path: 'choose-appointment',
    name: 'appointment-booking-choose-appointment',
    component: ChooseAppointmentView,
    meta: {
      ...defaultMetaAppointmentBooking,
      layoutPageTitle: 'Choose an appointment',
      pageTitle: 'Choose an appointment',
    },
  },
  {
    path: 'booked-successfully',
    name: 'appointment-booking-booked-successfully',
    component: AppointmentBookedView,
    meta: {
      ...defaultMetaAppointmentBooking,
      layoutPageTitle: null,
      pageTitle: 'Appointment booked',
      panelTitle: 'Appointment booked',
      backButton: false,
    },
  },
];

export default appointmentBookingChildren;
